import type { TextareaProps } from './Textarea'
import Textarea from './Textarea'

const TextareaPerFlag = (props: TextareaProps) => {
  return <Textarea {...props} />
}

export default TextareaPerFlag
